import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  ExportButton,
  Filter,
  EditButton,
  CreateButton,
  required,
} from 'react-admin';
const CodeFilter = (props) => (
  <Filter {...props}>
      <TextInput label="Name" source="name" alwaysOn />
  </Filter>
);

const MajorFieldActions = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    currentSort,
    total,
    exporter,
    basePath,
  } = props;

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={total}
      />
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const MajorFieldList = props => (
  <List {...props} filters={<CodeFilter/>} actions={<MajorFieldActions props={props} />}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Нэр" source="name" />
      <EditButton />
    </Datagrid>
  </List>
);

const MajorFieldTitle = ({ record }) => {
  return <span>MajorField {record ? `"${record.name}"` : ''}</span>;
};

export const MajorFieldEdit = props => (
  <Edit title={<MajorFieldTitle />} {...props}>
    <SimpleForm>
      <TextField label="ID" source="id" />
      <TextInput label="Нэр" source="name" validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const MajorFieldCreate = props => (
  <Create {...props}>
    <SimpleForm>
        <TextField label="ID" source="id" />
      <TextInput label="Нэр" source="name" validate={[required()]} />
    </SimpleForm>
  </Create>
);